import app from '@/app/store.js'
import Vue from 'vue'
import Vuex from 'vuex'
import common from './store/index.js'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    common: common,
    app: app
  },
  state () {
    return {}
  },
  mutations: {},
  getters: {},
  actions: {}
})



// WEBPACK FOOTER //
// ./src/common/store.js